const CHECKOUT_EVENTS = new Set([
  "initiateCheckout", "beginCheckout", "addPaymentInfo", "upsellAddPaymentInfo", "removeFromCart",
]);

// Normalize product fields and monetary units once, before sending to analytics providers.
export const getCheckoutEventProduct = (eventName, params, isNewT2) => {
  if (!CHECKOUT_EVENTS.has(eventName) || !params) return null;

  if (isNewT2) {
    const name = [
      params.title_thankyou_page,
      params.plan_name ?? params.upsale_name ?? params.name,
    ].filter(Boolean).join(" ");
    const amount = eventName === "removeFromCart"
      ? params.price_full
      : params.price_trial ?? params.price_full;
    return { value: amount / 100, productId: params.solidgate_product_id, name, itemName: name };
  }

  // Existing flows have separate product and prepared-order event contracts.
  switch (eventName) {
    case "beginCheckout":
      return {
        value: params.full_price,
        productId: params.product_id,
        name: params.plan_name,
        itemName: `${params.plan_name} ${params.thankyou_page_title}`,
      };
    case "upsellAddPaymentInfo":
      return {
        value: params.price || params.full_price,
        productId: params.product_id,
        name: params.plan_name,
        itemName: params.plan_name,
      };
    default:
      return {
        value: eventName === "removeFromCart" ? params.price_full : params.price,
        productId: params.solidgate_product_id,
        name: params.plan_name,
        itemName: `${params.title_thankyou_page} ${params.plan_name}${eventName === "addPaymentInfo" ? "" : " "}`,
      };
  }
};
